export const CategoryFilterRow = ({category, index, handleChange, categoryButtonsActive, initCategoryButtonsActive, ...props}) => {
    return <li key={category.id}>
        <button
            className={
                initCategoryButtonsActive
                    ? "sporttak active"
                    : categoryButtonsActive[index] ===
                        true
                        ? "sporttak active"
                        : "sporttak"
            }
            key={category.id}
            id={index}
            value={category.name}
            onClick={(event) =>
                handleChange(index, category.name)
            }
        >
            <i
                className={`sportkamp-${category.icon}`}
                value={category.name}
                aria-hidden="true"
            ></i>
            <p dangerouslySetInnerHTML={{__html: category?.title ? category?.title : category.name}}></p>
        </button>
    </li>;
}